/**
 * There's some kind of generic "show popover on hover" component to be extracted
 * from here and used between NavDropdownItemWithChildren and MultiSiteItemWithPopover.
 *
 * One of these two components may disappear.  I just.  Can't wrap my head around
 * it right now.  Like existential "what's even the point" can't wrap my head
 * around it.  F.
 */

import {FCWithChildren} from "@/app/types/reactTypes";
import MultiSiteItem, {MultiSiteItemProps} from "./MultiSiteItem";
import {useRef} from "react";
import {Dialog, Popover} from "react-aria-components";

interface MultiSiteItemWithPopoverProps extends Omit<MultiSiteItemProps, "id"> {
	id: string;
	isOpen: boolean;
}

const MultiSiteItemWithPopover: FCWithChildren<
	MultiSiteItemWithPopoverProps
> = ({children, isOpen, onMouseEnter, onMouseLeave, ...multiSiteItemProps}) => {
	const menuTriggerRef = useRef<HTMLAnchorElement | null>(null);
	const containerRef = useRef<HTMLDivElement | null>(null);
	return (
		<div
			ref={containerRef}
			className="group"
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onClick={onMouseLeave}
		>
			<MultiSiteItem ref={menuTriggerRef} {...multiSiteItemProps} />
			<Popover
				isOpen={isOpen}
				triggerRef={menuTriggerRef}
				isNonModal
				containerPadding={0}
				offset={0}
				className="hidden flex-col items-start sm:flex"
				placement="bottom start"
				UNSTABLE_portalContainer={containerRef.current ?? undefined}
			>
				<Dialog className="outline-0" aria-labelledby={multiSiteItemProps.id}>
					{children}
				</Dialog>
			</Popover>
		</div>
	);
};

export default MultiSiteItemWithPopover;
